import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import awsAuthService from '../services/aws/awsAuthService';
import awsRumService from '../services/aws/rum/awsRum';
import log from '../services/logger/log';
import {selectIsAuthorized} from '../state/selectors/auth';

const useAwsRum = () => {
    const isAuthorized = useSelector(selectIsAuthorized);

    useEffect(() => {
        awsRumService.initAwsRum();
    }, []);

    useEffect(() => {
        const manageAwsCredentials = async () => {
            if (!isAuthorized) return;

            try {
                const credentials = await awsAuthService.getCredentials();

                awsRumService.setAwsCredentials(credentials);

                await awsRumService.addSessionAttributes();

                awsRumService.enable();
            } catch (e) {
                log.error('Error managing AWS credentials:', e?.message);
            }
        };

        if (isAuthorized) {
            void manageAwsCredentials();
        } else {
            awsRumService.disable();
        }
    }, [isAuthorized]);
};

export default useAwsRum;
